// extracted by mini-css-extract-plugin
export default {"learnMoreBtn":"CookiePopup_learnMoreBtn__47Lk-"};